import { useMemo } from 'react';
import { CONFIG } from '~/_shared/constants/config';
import { useIsMapPresentationalSelector } from '~/store/selectors/useMapInfoSelectors';

export const useIsExportReportAvailable = () => {
  const isMapPresentational = useIsMapPresentationalSelector();

  const isExportReportAvailable = useMemo(() => {
    return CONFIG.ENABLE_PDF_EXPORT && !isMapPresentational;
  }, [isMapPresentational]);

  return {
    isExportReportAvailable,
  };
};
